import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Mail = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M4 12C4 10.3431 5.34315 9 7 9H33C34.6569 9 36 10.3431 36 12V28C36 29.6569 34.6569 31 33 31H7C5.34315 31 4 29.6569 4 28V12ZM7.72046 11L20 19.7711L32.2795 11H7.72046ZM34 12.2289L20.5812 21.8137C20.2335 22.0621 19.7665 22.0621 19.4188 21.8137L6 12.2289V28C6 28.5523 6.44772 29 7 29H33C33.5523 29 34 28.5523 34 28V12.2289Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Mail;
